import './temp_storage.css';
import React, { useState, useEffect } from "react";

import { UPDATE_TEMPORARY_STORAGE, GET_STAKEHOLDER_BY_URN, ADD_STORAGE, authKey, ResourceUpdateMember, GET_ADDRESS_BY_IFSC } from '../../../../common/URLs';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { ADDRESS_ERROR, APPLICANT_ERROR, LAND_DOCUMENT, BLOCK_LIST, CONTACT_PERSON_FIRST_NAME_ERROR, GENDER, MOBILE_NO_ERROR, PINCODE_NO_ERROR, REVENUE_BLOCK_DEFAULT_VALUE, REVENUE_CIRCLE, SALUTATION, SEARCH_ICON_ERROR, VALID_NAME_OF_APPLICANT, VALID_NAME_OF_APPLICANT_ERROR, LAND_AREA_UNIT, LAND_AREA_ERROR, CONSTANTS, LESS_THAN_2_FEET, MORE_THAN_2_FEET, ROLES, LINKS } from '../../../../common/constants';
import { LATITUDE_ERROR, LONGITUDE_ERROR, OTP_SENT_MESSAGE, INVALID_OTP_ERROR } from '../../../../common/constants';
import { GOV_ID_LIST, API_DATE_FORMAT, BASIC_DATE_FORMAT, LOI_ABRPL_AGREEMENT, GEOCODE_LOCATION, NON_ENCUMBRANCE_CERTI, VALATION_REPORT, GST, BTWN_100_500_METER, BTWN_4_6_HR, BTWN_500_1_METER, BTWN_6_8_HR, MORE_THAN_8_HR, ROAD_PHOTO, WITHIN_100_METER, ID_PROOF, PAN_CARD, PHOTO, SAVE_EXIT_API, SUBMIT_API, BANK_CANCELLED_CHEQUE } from '../../../../common/constants';
import { loaderService } from '../../../../common/custom-loader/loader-service';
import { sendOTP, validateOTP } from '../../../../common/Utils';
import resolveIcon from "../../../../images/resolved.png";
import jwt from 'jwt-decode';
import moment from 'moment';
import Preview from '../../registration/preview';
import { landAreaValidation, typeDecimalValid, maxNameLength, emailUrnPassMaxLength, govtIDcardLength, addressMaxLength, mobileNoMaxLength, mobileNumberValidation, nameValidation, pincodeValidation, typeNumberValid } from '../../../../common/commonValidations';
import { VALIDATION } from "../../../../common/commonValidations";
import { DialogContent, Dialog, DialogActions } from '@mui/material';
import { FileUploadMUI } from '../../../../common/fileUpload/fileUploadMUI';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { PROD } from '../../../../common/constants';
import { appCountDisplay } from '../../registration/dashboardStakeHolder';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import BackButton from '../../../../common/backButton';
import { Button, Container, Card, CardContent, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel } from '@mui/material';
import { CommonPincodeMUI } from '../../../../common/common-pincode/commonPincodeMUI';
import InputAdornment from '@mui/material/InputAdornment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocationPointMUI } from '../../../../common/locationPoints/locationPointMUI';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { ConfirmationPopover } from '../../../../common/commonPopovers/confirmationPopover';
import { PreRegPopover } from '../../../../common/commonPopovers/preRegPopver';
import { handleNumberFieldFocus } from '../../../../common/commonFunction';
import { ArrowBackIosNewIcon, ArrowForwardIosIcon, SaveIcon, SubmitIcon } from '../../../../common/icons';
import BadgeComponent from '../../../../common/badge';
import apiClient from '../../../../axios';


const TemporaryStorageDetails = (isPreReg) => {
    const { state } = useLocation();
    const { t, i18n } = useTranslation();
    isPreReg = isPreReg ? isPreReg.isPreReg : state?.isPreReg;
    const [verifyMobileNo, setVerifyMobileNo] = useState(false);
    const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
    const [otpHidden, setOtpHidden] = useState(true);
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const [roadConnectivity, setRoadConnectivity] = useState("Adjacent to an existing bitumen/block road");
    const [optedLocationPowerConnectionDistance, setOptedLocationPowerConnectionDistance] = useState(WITHIN_100_METER);
    const [daytimePowerAvailability, setDaytimePowerAvailability] = useState(MORE_THAN_8_HR);
    const [landArea, setLandArea] = useState('');
    const [landAreaUnit, setLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
    const [bankDetails, setBankDetails] = useState();
    const [agreementStartDateDisplay, setAgreementStartDateDisplay] = useState();
    const [agreementEndDateDisplay, setAgreementEndDateDisplay] = useState();
    const [ownershipType, setOwnershipType] = useState("Owned");
    const [landFillingRequired, setLandFillingRequired] = useState(false);
    const [updateResponse, setUpdateResponse] = useState();
    const [submit, setSubmit] = useState(false);
    const [saveAndExit, setSaveAndExit] = useState(false);
    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleConfirmLogModalClose = () => setLogModalOpen(false);
    const handleLogModalOpen = () => setLogModalOpen(true);

    const [logModalOpenPreReg, setLogModalOpenPreReg] = useState(false);
    const handlePreRegLogModalClose = () => setLogModalOpenPreReg(false);
    const handlePreRegLogModalOpen = () => setLogModalOpenPreReg(true);

    const [logModalOpenSuccess, setLogModalOpenSuccess] = useState(false);
    const handleLogModalSuccessOpen = () => setLogModalOpenSuccess(true);
    const handleLogModalSuccessClose = () => setLogModalOpenSuccess(false);

    const [documentArray, setDocumentArray] = useState([]);
    let userRole = localStorage.getItem('role');
    const [registrationtrue, setRegistrationtrue] = useState();
    const decoded = getLocalStorageItem('id_token') ? (getLocalStorageItem('id_token') == "PreReg") ? null : jwt(getLocalStorageItem('id_token')) : null;
    const [loadPreview, setLoadPreview] = useState(false);
    const [populateDetails, setPopulateDetails] = useState();
    const initialData = {
        id: "",
        name: "",
        contactPersonName: "",
        contactPersonFirstname: "",
        contactPersonMiddlename: "",
        contactPersonLastname: "",
        contactPersonGender: GENDER[0],
        contactPersonSalutation: SALUTATION[0],
        mobileNo: "",
        isOtpValidated: mobileOTPValidated,
        bankAccountNumber: "",
        bankAccountHolderName: "",
        bankBranch: "",
        bankIfscCode: "",
        panNumber: "",
        govtIdCardType: "Aadhaar ID",
        govtIdCardNumber: "",
        otherGovtCardType: "",
        emailId: "",
        category: "",
        urn: "",
        preregistrationShortlisted: true,
        registrationStatus: "",
        scrutinyStatus: "",
        stakeholderStatus: true,
        createdOn: "",
        createdBy: "",
        updatedOn: "",
        updatedBy: "",
        isActive: 0,
        temporaryStorageDetail: {
            id: "",
            regStakeholderMasterId: "",
            officeAddress: "",
            officeDistrict: "",
            officeSubDivision: "",
            officeState: "",
            officePincode: "",
            officeRevenueCircle: "",
            officeBlockName: "",
            typeOfApplicant: "",
            landArea: "",
            landAreaUnit: LAND_AREA_UNIT[0],
            longitude: "",
            latitude: "",
            netWorth: "",
            storagePincode: "",
            storageAddress: "",
            storageState: "",
            storageDistrict: "",
            storageRevenueCircle: "",
            storageBlockName: "",
            storageSubDivision: "",
            workingCapital: "",
            isRoadConnectivityValid: true,
            roadConnectivity: "",
            optedLocationPowerConnectionDistance: "",
            isAlternatePowerSupplyAvailable: true,
            daytimePowerAvailability: "",
            gstNumber: "",
            nonEncumbranceCertificateNo: "",
            agreementStartDate: '',
            agreementEndDate: '',
            locationGeotag: "",
            ownershipType: "Owned",
            landFillingRequired: false,
            landFillingType: "",
            existingBoundaryWall: false,
            isExistingInfrastructure: false,
            createdOn: "",
            createdBy: "",
            updatedOn: "",
            updatedBy: "",
            isActive: 0,
            documents: []
        }
    }
    const [details, setDetails] = useState(initialData);
    const [hidden, setHidden] = useState({
        div1: false,
        div2: true,
        div3: true,
        div4: true,
        divPreview: true
    });
    const navigate = useNavigate();
    const [storageDetails, setstorageDetails] = useState();
    const [storageError, setStorageError] = useState('');
    const [otpValue, setOtpValue] = useState()
    const initialError = {
        fullNameError: '',
        contactPersonNameError: '',
        mobileNoError: '',
        pincodeError: '',
        searchError: '',
        addressError: '',
        emailIdError: '',
        netWorthError: '',
        workingCapitalError: '',
        locationPincodeError: '',
        locationSearchError: '',
        locationAddressError: '',
        landAreaError: '',
        latitudesError: '',
        longitudesError: '',
        OTPError: '',
        OTPSentError: '',
        bankAccountError: '',
        accountHolderNameError: '',
        ifscError: '',
        bankBranchError: '',
        agreementSatrtDateError: '',
        agreementEndDateError: '',
        gstError: '',
        nonEncumCertError: '',
        documentError: '',
        panNumberError: '',
        idProofDocError: '',
        idCardNumberError: '',
        bankDocError: '',
        gstDocError: '',
        nonEncumDocError: '',
        valuationDocError: '',
        agreementDocError: '',
        locationDocError: '',
        landDocError: '',
        documentError: '',
        panDocError: '',
        otherCardError: ''
    }
    const [errorMessage, setErrorMessage] = useState(initialError);
    const [checkTermChecked, setCheckTermChecked] = useState(false);
    const [checkTermDisable, setCheckTermDisable] = useState(false);
    const [nextClick, setNextClick] = useState(0);
    const [loc, setLoc] = useState();

    useEffect(() => {
        if (getLocalStorageItem('id_token') && getLocalStorageItem('id_token') !== "PreReg") {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const decoded_urn = decoded.extension_URN
            setLoc(decoded_urn);
        }
    }, [getLocalStorageItem('id_token')]);


    useEffect(() => {
        let userRole = localStorage.getItem('role');
        if (ResourceUpdateMember.includes(userRole)) {
            setDetails({ ...details, urn: state?.URN })
        }
        else if (getLocalStorageItem('id_token') && getLocalStorageItem('id_token') !== "PreReg" && !isPreReg) {
            const decoded = jwt(getLocalStorageItem('id_token'))
            setDetails({ ...details, urn: decoded.extension_URN })
        }
    }, [])

    useEffect(() => {
        if ((details.urn && !isPreReg) || (nextClick && !isPreReg)) {
            loaderService.showLoader()
            apiClient.post(GET_STAKEHOLDER_BY_URN,
                {
                    "urn": details.urn,
                    "isScrutinyView": "true"
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
                .then((response) => {
                    if (response && response.data && response.data.stakeHolder) {
                        setPopulateDetails(response.data.stakeHolder);
                        loaderService.hideLoader();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    loaderService.hideLoader();
                });

        }
    }, [details.urn, nextClick]);

    const clear = (e) => {
        setDetails(initialData);
        setMobileOTPValidated(false);
        setCheckTermChecked(false);
        setCheckTermDisable(false);
        setOtpHidden(true);
        setVerifyMobileNo(false);
        setErrorMessage(initialError);
    }

    const handleCheckboxTerms = (e) => {
        if (e.target.checked) {
            e.preventDefault();
            setErrorMessage({ ...errorMessage, OTPError: "" });
            setOtpValue("");
            if (isValidMobileNumber(details.mobileNo)) {
                sendOTP(details.mobileNo, callBackMobileValidation);
                setErrorMessage({ ...errorMessage, mobileNoError: "", acceptTermError: "" });
                setCheckTermChecked(true);
                setCheckTermDisable(true);
            }
            else {
                setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
                setCheckTermChecked(false);
            }
        }
    }
    function getBankDetails() {
        apiClient
            .post(GET_ADDRESS_BY_IFSC,
                {
                    "ifsc": details.bankIfscCode,
                },
                {
                    headers: {
                        AuthKey: authKey,
                    },
                }
            )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    setBankDetails(response.data);
                    setErrorMessage({ ...errorMessage, ifscCodeError: "" });
                }
                else {
                    setDetails({
                        ...details, bankBranch: " ", bankIfscCode: " ",
                    });

                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }
    const onGoBack = () => {
        setNextClick(nextClick + 1);
        setHidden({ ...hidden, div1: true, div2: true, div3: true, div4: false, divPreview: true })
    }
    const setOfficeAddressData = (data) => {
        setErrorMessage({ ...errorMessage, pincodeError: "" })
        setDetails(current => {
            return {
                ...current, temporaryStorageDetail:
                {
                    ...current.temporaryStorageDetail,
                    officePincode: data.pincode,
                    officeState: data.pincodeState,
                    officeDistrict: data.pincodeDistrict,
                    officeSubDivision: data.pincodeSubDivision,
                    officeRevenueCircle: data.selectedRevenueCircle,
                    officeBlockName: data.selectedBlockName
                }
            };
        });
    }
    const handleOfficeChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, officeBlockName: e.target.value } };
            });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, officeRevenueCircle: e.target.value } };
            });
        }
    }
    const setStorageAddressData = (data) => {
        setErrorMessage({ ...errorMessage, locationPincodeError: "" })
        setDetails(current => {
            return {
                ...current, temporaryStorageDetail:
                {
                    ...current.temporaryStorageDetail,
                    storagePincode: data.pincode,
                    storageState: data.pincodeState,
                    storageDistrict: data.pincodeDistrict,
                    storageSubDivision: data.pincodeSubDivision,
                    storageRevenueCircle: data.selectedRevenueCircle,
                    storageBlockName: data.selectedBlockName
                }
            };
        });
    }
    const handleStorageChangeSelect = (e, type) => {
        if (type == BLOCK_LIST) {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, storageBlockName: e.target.value } };
            });
        }
        if (type == REVENUE_CIRCLE) {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, storageRevenueCircle: e.target.value } };
            });
        }
    }
    //const populateDetails = (data) => {

    useEffect(() => {
        if (populateDetails) {
            let data = populateDetails;
            setDetails({ ...data, temporaryStorageDetail: { ...data.temporaryStorageMasters[0], agreementStartDate: data.temporaryStorageMasters[0].agreementStartDate, agreementEndDate: data.temporaryStorageMasters[0].agreementEndDate }, govtIdCardType: populateDetails.govtIdCardType ? populateDetails.govtIdCardType : data.temporaryStorageMasters[0].typeOfApplicant == "Individual" ? "Aadhaar ID" : "MOA" });
            const spaceIndex = data.temporaryStorageMasters[0].landArea?.indexOf(" ");
            const numberPart = data.temporaryStorageMasters[0].landArea?.slice(0, spaceIndex);
            const unitPart = data.temporaryStorageMasters[0].landArea?.slice(spaceIndex + 1);
            setAgreementStartDateDisplay(data.temporaryStorageMasters[0].agreementStartDate && moment(data.temporaryStorageMasters[0].agreementStartDate).format(BASIC_DATE_FORMAT))
            setAgreementEndDateDisplay(data.temporaryStorageMasters[0].agreementEndDate && moment(data.temporaryStorageMasters[0].agreementEndDate).format(BASIC_DATE_FORMAT))
            setLandArea(numberPart);
            setLandAreaUnit(unitPart);
            setMobileOTPValidated(data.isOtpValidated);
            setRoadConnectivity(data.temporaryStorageMasters[0].roadConnectivity);
            setDaytimePowerAvailability(data.temporaryStorageMasters[0].daytimePowerAvailability);
            setOptedLocationPowerConnectionDistance(data.temporaryStorageMasters[0].optedLocationPowerConnectionDistance);
            setDocumentArray(data.temporaryStorageMasters[0].documents);
            setSelectedApplicant(data.temporaryStorageMasters[0].typeOfApplicant);
            setRegistrationtrue(data?.registrationCompleted);
        }
    }, [populateDetails]);

    const handleDateChange = (e, name) => {
        // e.preventDefault()
        //console.log("e", e.format("YYYY-MM-DD"))
        let selectedDate = e.format(BASIC_DATE_FORMAT)
        let formattedDate = moment(selectedDate).format(API_DATE_FORMAT)
        if (name == "startDate") {
            setAgreementStartDateDisplay(selectedDate);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, agreementStartDate: formattedDate } };
            });
        }
        else {
            setAgreementEndDateDisplay(selectedDate);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, agreementEndDate: formattedDate } };
            });
        }
    }

    useEffect(() => {
        if (storageDetails) {
            if (storageDetails.temporaryStorage) {
                handleLogModalSuccessOpen();
            }
            if (!storageDetails?.isSuccess) {
                toast.error(storageDetails?.message)
            }
        }
    }, [storageDetails]);

    useEffect(() => {
        if (updateResponse && submit) {
            if (updateResponse?.isSuccess) {
                toast.success("Interim Storage Operator updated successfully")
                if (ResourceUpdateMember.includes(userRole) && userRole === 'Reg-ITAdmin') {
                    navigate("/sidebar/viewAllActiveApplications")
                }
                else if (ResourceUpdateMember.includes(userRole) && userRole === 'Res-Scmuser') {
                    navigate("/resourcedashboard/searchByURN")
                }
                else navigate('/dashboardHome/dashboardStakeHolder')
            }
            else toast.error(updateResponse.message)
        }
        if (saveAndExit) {
            if (ResourceUpdateMember.includes(userRole) && userRole === 'Reg-ITAdmin') {
                navigate("/sidebar/viewAllActiveApplications")
            }
            else if (ResourceUpdateMember.includes(userRole) && userRole === 'Res-Scmuser') {
                navigate("/resourcedashboard/searchByURN")
            }
            else navigate('/dashboardHome/dashboardStakeHolder')
        }
    }, [updateResponse])

    const submitPreReg = () => {
        handlePreRegLogModalClose();
        // e.preventDefault();
        loaderService.showLoader()
        let headers = {
            AuthKey: authKey,
        }
        if (getLocalStorageItem('id_token') && getLocalStorageItem('id_token') !== "PreReg") {
            headers = {
                AuthKey: authKey,
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
        }
        apiClient.post(ADD_STORAGE,
            {
                "typeOfApplicant": selectedApplicant,
                "name": details.name,
                "contactPersonName": details.contactPersonFirstname,
                "contactPersonFirstname": details.contactPersonFirstname,
                "contactPersonMiddlename": details.contactPersonMiddlename,
                "contactPersonLastname": details.contactPersonLastname,
                "contactPersonGender": details.contactPersonGender,
                "contactPersonSalutation": details.contactPersonSalutation,
                "mobileNo": details.mobileNo,
                "emailId": details.emailId,
                "officeAddress": details.temporaryStorageDetail.officeAddress,
                "officeDistrict": details.temporaryStorageDetail.officeDistrict,
                "officeSubDivision": "",
                "officeState": details.temporaryStorageDetail.officeState,
                "officePincode": details.temporaryStorageDetail.officePincode,
                "officeRevenueCircle": details.temporaryStorageDetail.officeRevenueCircle,
                "officeBlockName": details.temporaryStorageDetail.officeBlockName,
                "landArea": landArea + ' ' + landAreaUnit,
                "longitude": details.temporaryStorageDetail.latitude,
                "latitude": details.temporaryStorageDetail.longitude,
                "netWorth": details.temporaryStorageDetail.netWorth,
                "storagePincode": details.temporaryStorageDetail.storagePincode,
                "storageAddress": details.temporaryStorageDetail.storageAddress,
                "storageState": details.temporaryStorageDetail.storageState,
                "storageDistrict": details.temporaryStorageDetail.storageDistrict,
                "storageRevenueCircle": details.temporaryStorageDetail.storageRevenueCircle,
                "storageBlockName": details.temporaryStorageDetail.storageBlockName,
                "storageSubDivision": "",
                "workingCapital": details.temporaryStorageDetail.workingCapital,
                "ownershipType": details.temporaryStorageDetail.ownershipType,
                "landFillingRequired": details.temporaryStorageDetail.landFillingRequired,
                "landFillingType": details.temporaryStorageDetail.landFillingType,
                "existingBoundaryWall": details.temporaryStorageDetail.existingBoundaryWall,
                "isExistingInfrastructure": details.temporaryStorageDetail.isExistingInfrastructure,
                "existingInfrastructureOnPlot": details.temporaryStorageDetail.existingInfrastructureOnPlot,
                "roadConnectivity": roadConnectivity,
                "optedLocationPowerConnectionDistance": optedLocationPowerConnectionDistance,
                "daytimePowerAvailability": daytimePowerAvailability,
                "isOtpValidated": mobileOTPValidated,
                "acceptedTerms": checkTermChecked,
                documents: documentArray
            },
            {
                headers: headers,
            }
        )
            .then((response) => {
                if (!response.data.isSuccess && response.data.message.indexOf("mobile number") >= 0) {
                    setVerifyMobileNo(false);
                    setMobileOTPValidated(false);
                    setCheckTermChecked(false);
                    setCheckTermDisable(false);
                }
                setstorageDetails(response.data);
                loaderService.hideLoader()
            })
            .catch(function (error) {
                setStorageError(error);
                loaderService.hideLoader()
            });
    }

    const showPreview = (e) => {
        e.preventDefault();
        saveRegistration(false);
        setLoadPreview(!loadPreview);
        setHidden({ ...hidden, div1: true, div2: true, div3: true, div4: true, divPreview: false })

    }
    const confirmSubmission = (e, isRegistrationSubmit) => {
        e.preventDefault();
        handleLogModalOpen();

    }
    const confirmSubmissionPreReg = (e, isRegistrationSubmit) => {
        e.preventDefault();
        handlePreRegLogModalOpen();

    }
    const SaveAndExit = () => {
        saveRegistration(false);
        setSaveAndExit(true);
    }
    const Submit = () => {
        handleConfirmLogModalClose();
        saveRegistration(true);
        setSubmit(true);
    }
    const getSubmit = (submit) => {
        if (userRole == ROLES.ItAdmin) {
            return false;
        }
        else {
            return submit;
        }

    }
    const saveRegistration = (isRegistrationSubmit) => {
        let newDetails = { ...details };
        delete newDetails.growerMasters;
        delete newDetails.hitMasters;
        delete newDetails.lleMasters;
        delete newDetails.transporterMasters;
        delete newDetails.temporaryStorageMasters;

        let tempStorage = { ...details.temporaryStorageDetail };
        delete tempStorage.regStakeholderMaster;
        newDetails.temporaryStorageDetail = tempStorage;
        if (userRole !== ROLES.ItAdmin) {
            if (isRegistrationSubmit && (ResourceUpdateMember.includes(userRole) || newDetails.registrationStatus == "Approved")) {
                newDetails.registrationStatus = "ResourceUpdate";
            }
        }
        setDetails(newDetails);
        loaderService.showLoader();
        var URL = UPDATE_TEMPORARY_STORAGE + `?IsRegistrationSubmit=${getSubmit(isRegistrationSubmit)}`
        apiClient.post(URL,
            JSON.stringify(newDetails),
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                },
            }
        )
            .then((response) => {
                setNextClick(nextClick + 1);
                setUpdateResponse(response.data);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }
    useEffect(() => {
        if (bankDetails) {
            setDetails({
                ...details, bankBranch: bankDetails?.branch
            });
        }
    }, [bankDetails]);

    const onClickVerifyMobileNo = (e) => {
        e.preventDefault();
        setErrorMessage({ ...errorMessage, OTPError: "" });
        setOtpValue("");
        if (isValidMobileNumber(details.mobileNo)) {
            sendOTP(details.mobileNo, callBackMobileValidation);
        }
        else
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
    }

    const callBackMobileValidation = (response) => {
        if (response.isSuccess) {
            setErrorMessage({ ...errorMessage, OTPSentError: "", mobileNoError: "", OTPError: "", acceptTermError: "" })
            setVerifyMobileNo(true);
            setOtpHidden(false);
        }

    }

    const callbackIFSCCheck = (response) => {
        if (response.isSuccess) {
            setDetails({ ...details, bankBranch: response.branch })
        }

    }

    const onOtpChange = (e) => {
        const limit = 6;
        setOtpValue(e.target.value.slice(0, limit))
        if (e.target.value.length == 6) {
            validateOTP(details.mobileNo, e.target.value, callBackOTPValidation);
        }
    }

    const callBackOTPValidation = (response) => {
        setErrorMessage({ ...errorMessage, OTPSentError: "", OTPError: "", mobileNoError: "", acceptTermError: "" });
        if (response.isSuccess) {
            setVerifyMobileNo(false);
            setOtpHidden(true);
            setMobileOTPValidated(true);
            setDetails({ ...details, isOtpValidated: true })
        }
        else {
            setErrorMessage({ ...errorMessage, OTPError: INVALID_OTP_ERROR });
        }
    }

    const onLocationPoint = (position) => {
        setDetails(current => {
            return {
                ...current, temporaryStorageDetail:
                {
                    ...current.temporaryStorageDetail,
                    latitude: position?.coords?.latitude ? position?.coords?.latitude : position.Latitude,
                    longitude: position?.coords?.longitude ? position?.coords?.longitude : position.Longitude
                }
            };
        });
    }

    const isValidMobileNumber = (mobileNo) => {
        if (mobileNo.length == 10) {
            return true;
        }
        return false;
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const onNextClick = (divName) => {
        if (divName == 'div1') {
            if (isPreReg)
                setHidden({ ...hidden, div1: true, div2: true, div3: false, div4: true })
            else
                setHidden({ ...hidden, div1: true, div2: false, div3: true, div4: true })
        }
        if (divName == 'div2') {
            setHidden({ ...hidden, div1: true, div2: true, div3: false, div4: true })
        }
        if (divName == 'div3') {
            setHidden({ ...hidden, div1: true, div2: true, div3: true, div4: false })
        }
    }
    const roadConnectivityChange = (e) => {
        setRoadConnectivity(e.target.value)
    }
    const optedLocationPowerConnectionDistanceChnage = (e) => {
        setOptedLocationPowerConnectionDistance(e.target.value)
    }
    const onDaytimePowerAvailabilityChange = (e) => {
        setDaytimePowerAvailability(e.target.value)
    }
    const onUploadCallBack = (docArray) => {
        setDocumentArray(docArray);
        setDetails(current => {
            return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, documents: docArray } };
        });
    }
    const handleChange = (e) => {
        if (e.target.name === "name") {
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) })
                if (nameValidation(e.target.value)) {
                    setErrorMessage({ ...errorMessage, fullNameError: "" })
                } else setErrorMessage({ ...errorMessage, fullNameError: VALID_NAME_OF_APPLICANT_ERROR })
            } else {
                setErrorMessage({ ...errorMessage, fullNameError: APPLICANT_ERROR })
                setDetails({ ...details, [e.target.name]: e.target.value })
            }
        }
        if (e.target.name === "contactPersonGender" || e.target.name === "contactPersonSalutation") {
            setDetails({ ...details, [e.target.name]: e.target.value });
        }
        if (e.target.name === "bankBranch") {
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, ifscError: "" })
            } else {
                setErrorMessage({ ...errorMessage, ifscError: "Please search IFSC code" })

            }
            setDetails({ ...details, [e.target.name]: e.target.value });
        }

        if (e.target.name === 'bankIfscCode') {
            setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '') });
            if (e.target.value.length > 0 && VALIDATION.ifscValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, ifscError: "" })
                setDetails({ ...details, [e.target.name]: e.target.value, bankBranch: "" });
            } else setErrorMessage({ ...errorMessage, ifscError: "Please enter valid IFSC Code" })
        }

        if (e.target.name === "bankAccountNumber") {
            const limit = 18;
            if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.toUpperCase().slice(0, limit))) {
                setErrorMessage({ ...errorMessage, bankAccountError: "" })
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) });
            } else {
                setErrorMessage({ ...errorMessage, bankAccountError: 'Please enter valid Account Number' })

            }
        }
        if (e.target.name === "bankAccountHolderName") {
            setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value) });
            if (e.target.value.length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, accountHolderNameError: "" })
            } else {
                setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })

            }
        }
        if (e.target.name === 'otherGovtCardType') {
            const limit = 50;
            if (e.target.value.length > 0) {
                setDetails({ ...details, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.toUpperCase()).slice(0, limit) });
                setErrorMessage({ ...errorMessage, otherCardError: '' })
            }
            else {
                setErrorMessage({ ...errorMessage, otherCardError: 'Please enter ID Proof Name' })
            }
        }
        if (e.target.name === "officeAddress") {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 300)) }, };
            });
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, addressError: "" })
            } else {
                setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR })

            }

        }

        if (e.target.name === "contactPersonFirstname") {
            const Firstname_regex = /^[a-zA-Z]+$/;
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if (!(details.contactPersonFirstname.match(Firstname_regex))) {
                setErrorMessage({ ...errorMessage, contactPersonNameError: VALID_NAME_OF_APPLICANT_ERROR })
            }
            else {
                setErrorMessage({ ...errorMessage, contactPersonNameError: "" })
            }
        }
        if (e.target.name === "contactPersonMiddlename") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            } else return
        }
        if (e.target.name === "contactPersonLastname") {
            setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            if ((e.target.value).length > 0) {
                setDetails({ ...details, [e.target.name]: nameValidation(e.target.value) })
            } else return
        }
        if (e.target.name === "mobileNo") {
            var slicedMobileNumber = mobileNumberValidation(e.target.value);
            setDetails({ ...details, [e.target.name]: slicedMobileNumber })
            if (slicedMobileNumber.length != 10) {
                setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
            }
            else setErrorMessage({ ...errorMessage, mobileNoError: "" });

        }
        if (e.target.name === "officePincode") {
            var slicedPincode = pincodeValidation(e.target.value);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
            });
            if (slicedPincode.length != 6) {
                setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            }
            else setErrorMessage({ ...errorMessage, pincodeError: "" });
        }
        if (e.target.name === "storagePincode") {
            var slicedPincode = pincodeValidation(e.target.value);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
            });
            if (slicedPincode.length != 6) {
                setErrorMessage({ ...errorMessage, locationPincodeError: PINCODE_NO_ERROR });
            }
            else setErrorMessage({ ...errorMessage, locationPincodeError: '' });
        }
        if (e.target.name === "emailId") {
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, 50) })
            if ((e.target.value).length > 0) {
                if (isValidEmail(e.target.value)) {
                    setErrorMessage({ ...errorMessage, emailIdError: "" })
                } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter a valid Email Address" })
            } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" })
        }
        if (e.target.name === "netWorth") {
            const limit = 10;
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
            });
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, netWorthError: "" })
            } else {
                setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth" })

            }
        }
        if (e.target.name === "workingCapital") {
            const limit = 10;
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
            });
            if ((e.target.value).length > 0) {
                setErrorMessage({ ...errorMessage, workingCapitalError: "" })
            } else {
                setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital" })

            }
        }
        if (e.target.name === "storageAddress") {
            if ((e.target.value).length == 0) {
                setErrorMessage({ ...errorMessage, locationAddressError: ADDRESS_ERROR });
            }
            else setErrorMessage({ ...errorMessage, locationAddressError: "" });
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 300)) }, };
            });
        }
        if (e.target.name === "landArea") {
            var slicedLandArea = landAreaValidation(e.target.value);
            setLandArea(slicedLandArea);
            if (slicedLandArea.length == 0) {
                setErrorMessage({ ...errorMessage, landAreaError: LAND_AREA_ERROR });
            }
            else setErrorMessage({ ...errorMessage, landAreaError: "" });
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: slicedLandArea + ' ' + landAreaUnit }, };
            });
        }
        if (e.target.name === "landAreaUnit") {
            setLandAreaUnit(e.target.value);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: landArea + ' ' + e.target.value }, };
            });
        }
        if (e.target.name === "latitude") {
            const limit = 18;
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
            });

            if ((e.target.value).length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, latitudeError: "" })
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
                });

            } else {
                setErrorMessage({ ...errorMessage, latitudeError: "Please enter valid latitude" })

            }
        }
        if (e.target.name === "longitude") {
            const limit = 18;
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
            }); if ((e.target.value).length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, longitudesError: "" })
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.slice(0, limit) }, };
                });

            } else {
                setErrorMessage({ ...errorMessage, longitudesError: "Please enter valid longitude" })

            }
        }
        if (e.target.name === "gstNumber") {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.toUpperCase() }, };
            });
            if ((e.target.value).length == 0) {
                setErrorMessage({ ...errorMessage, gstError: "Please enter GST Number" });
            }
            else {
                if (e.target.value.length > 0 && VALIDATION.gstNumberValidation(e.target.value)) {
                    setErrorMessage({ ...errorMessage, gstError: "" });
                } else setErrorMessage({ ...errorMessage, gstError: 'Invalid GST Number' })
            }
        }
        if (e.target.name === "nonEncumbranceCertificateNo") {
            if ((e.target.value).length == 0) {
                setErrorMessage({ ...errorMessage, nonEncumCertError: "Please enter non encumbrance certificate no" });
            }
            else setErrorMessage({ ...errorMessage, nonEncumCertError: "" });
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: VALIDATION.noSpecialCharCapsValidation(e.target.value.toUpperCase().slice(0, 50)) }, };
            });
        }
        if (e.target.name === "panNumber" || e.target.name === "govtIdCardType" || e.target.name === "govtIdCardNumber") {
            if (e.target.name === "panNumber") {
                setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase().replace(/[^a-zA-Z0-9]/gi, '') },)
                // setDetails(current => {
                //     return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value.replace(/[^a-zA-Z0-9]/gi, '') }, };
                // });
                if (e.target.value.length > 0 && VALIDATION.panNumberValidation(e.target.value)) {
                    setErrorMessage({ ...errorMessage, panNumberError: "" })
                    setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase() },)
                    // setDetails(current => {
                    //     return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
                    // });
                } else setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
            }
            else if (e.target.name === "govtIdCardNumber") {
                setErrorMessage({ ...errorMessage, idCardNumberError: "" })
                if (details.govtIdCardType == "Aadhaar ID") {
                    var govtIDNumber = e.target.value.replace(/[^0-9]/gi, '').slice(0, 4);
                    setDetails({ ...details, [e.target.name]: govtIDNumber })
                }
                else
                    setDetails({ ...details, [e.target.name]: e.target.value.toUpperCase().slice(0, (details.govtIdCardType === "Registration Certificate" || details.govtIdCardType === "MOA") ? 30 : 20) })
            }
            else
                setDetails({ ...details, [e.target.name]: e.target.value })
        }
        if (e.target.name === "agreeementStartDate") {
            if (details.temporaryStorageDetail.agreementStartDate > details.temporaryStorageDetail.agreementEndDate) {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "Agreement Start Date can not be greater than Agreement End Date" });
            }
            else {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "" });
            }
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
            });
        }
        if (e.target.name === "agreementEndDate") {
            if (details.temporaryStorageDetail.agreementStartDate > details.temporaryStorageDetail.agreementEndDate) {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "Agreement Start Date can not be greater than Agreement End Date" });
            }
            else {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "" });
            }
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: e.target.value }, };
            });
        }
        if (e.target.name === "existingInfrastructureOnPlot") {
            if ((e.target.value).length == 0) {
                setErrorMessage({ ...errorMessage, locationAddressError: ADDRESS_ERROR });
            }
            else setErrorMessage({ ...errorMessage, locationAddressError: "" });
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) }, };
            });
        }
    }
    const onPrevious = (e) => {
        e.preventDefault();
        if (!hidden.div2) {
            setHidden({ ...hidden, div1: false, div2: true, div3: true, div4: true })
        }
        if (!hidden.div3) {
            if (isPreReg)
                setHidden({ ...hidden, div1: false, div2: true, div3: true, div4: true })
            else
                setHidden({ ...hidden, div1: true, div2: false, div3: true, div4: true })
        }
        if (!hidden.div4) {
            setHidden({ ...hidden, div1: true, div2: true, div3: false, div4: true })
        }
    };
    const onSubmit = (e) => {
        e.preventDefault();
        if (!hidden.div1) {
            if (validateDiv1())
                onNextClick('div1');
            else
                return false;
        }
        else if (!hidden.div2) {
            if (validateDiv2())
                onNextClick('div2');
            else
                return false;
        }
        else if (!hidden.div3) {
            if (validateDiv3())
                onNextClick('div3');
            else
                return false;
        }
    };
    const validateDiv1 = () => {
        if ((!details.name)) {
            setErrorMessage({ ...errorMessage, fullNameError: APPLICANT_ERROR });
            return false;
        }
        else if (!details.contactPersonFirstname) {
            setErrorMessage({ ...errorMessage, contactPersonNameError: CONTACT_PERSON_FIRST_NAME_ERROR });
            return false;
        }
        else if (!details.mobileNo || details.mobileNo.length != 10) {
            setErrorMessage({ ...errorMessage, mobileNoError: MOBILE_NO_ERROR });
            return false;
        }
        //else if (!mobileOTPValidated) {
        //    setErrorMessage({ ...errorMessage, mobileNoError: "Please validate Mobile No" });
        //    return false;
        //}
        else if (!details.emailId || !isValidEmail(details.emailId)) {
            setErrorMessage({ ...errorMessage, emailIdError: "Please enter a valid Email Address" })
            return false;
        }
        else if (!details.temporaryStorageDetail.officeAddress) {
            setErrorMessage({ ...errorMessage, addressError: ADDRESS_ERROR });
            return false;
        }
        else if (details.temporaryStorageDetail.officePincode.length != 6) {
            setErrorMessage({ ...errorMessage, pincodeError: PINCODE_NO_ERROR });
            return false;
        }
        else if (!details.temporaryStorageDetail.officeState) {
            setErrorMessage({ ...errorMessage, searchError: SEARCH_ICON_ERROR });
            return false;
        }
        else if (!checkTermChecked && isPreReg == true) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please accept the Privacy Policy and Terms of Use of ABEPL." });
            return false;
        }
        else if (!mobileOTPValidated && verifyMobileNo && isPreReg == true) {
            setErrorMessage({ ...errorMessage, acceptTermError: "Please enter the OTP sent to your mobile number" });
            return false;
        }
        else if (userRole !== ROLES.ItAdmin) {
            if (!isPreReg && details.temporaryStorageDetail.panNumber && !VALIDATION.panNumberValidation(details.temporaryStorageDetail.panNumber)) {
                setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
                return false;
            }
            else if (!isPreReg && details.govtIdCardType == "Other" && !details?.otherGovtCardType) {
                setErrorMessage({ ...errorMessage, otherCardError: "Please enter Card Type" })
                return false;
            }
            else if (!isPreReg && (!details.govtIdCardNumber || details.govtIdCardNumber?.length == 0)) {
                setErrorMessage({ ...errorMessage, idCardNumberError: "Please enter ID Proof Number" })
                return false;
            }
            var idProofDoc = documentArray && documentArray.filter((item) => item.documentType === ID_PROOF && item.isActive == 1);
            if (!isPreReg && (!idProofDoc || idProofDoc.length == 0)) {
                setErrorMessage({ idProofDocError: "Please upload ID Proof document" });
                return false;
            }
            else {
                setErrorMessage({ idProofDocError: "" });
            }
        }
        return true;
    }
    const validateDiv2 = () => {
        if (userRole !== ROLES.ItAdmin) {
            if (!details.bankAccountNumber || details.bankAccountNumber.length == 0 && !(VALIDATION.bankAccountNumberValidation(details.bankAccountNumber))) {
                setErrorMessage({ ...errorMessage, bankAccountError: 'Please enter valid Account Number' });
                return false;
            }
            else if (!details.bankAccountHolderName || details.bankAccountHolderName.length == 0 && !(VALIDATION.bankAccountNameValidation(details.bankAccountHolderName))) {
                setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" });
                return false;
            }
            else if (!details.bankIfscCode || details.bankIfscCode.length == 0 && !(VALIDATION.ifscValidation(details.bankIfscCode))) {
                setErrorMessage({ ...errorMessage, ifscError: "Please enter valid IFSC code." });
                return false;
            }
            else if (!details.bankBranch) {
                setErrorMessage({ ...errorMessage, ifscError: "Please enter valid IFSC code and search" });
                return false;
            }
            else if (!details.temporaryStorageDetail.gstNumber) {
                setErrorMessage({ ...errorMessage, gstError: "Please enter GST number" });
                return false;
            }
            else if (details.temporaryStorageDetail.gstNumber && errorMessage.gstError) {
                return false;
            }
            else if (!details.temporaryStorageDetail.nonEncumbranceCertificateNo) {
                setErrorMessage({ ...errorMessage, nonEncumCertError: "Please enter non encumbrance certificate no" });
                return false;
            } if (details.temporaryStorageDetail.agreementStartDate > details.temporaryStorageDetail.agreementEndDate) {
                setErrorMessage({ ...errorMessage, agreementSatrtDateError: "Agreement Start Date can not be greater than Agreement End Date" });
                return false;
            }
            var bankdoc = documentArray && documentArray.filter((item) => item.documentType === BANK_CANCELLED_CHEQUE && item.isActive == 1);
            if (bankdoc.length == 0) {
                setErrorMessage({ bankDocError: "Please upload bank document" });
                return false;
            }
            var gstdoc = documentArray && documentArray.filter((item) => item.documentType === GST && item.isActive == 1);
            if (gstdoc.length == 0) {
                setErrorMessage({ gstDocError: "Please upload gst document" });
                return false;
            }
            var nonEncumdoc = documentArray && documentArray.filter((item) => item.documentType === NON_ENCUMBRANCE_CERTI && item.isActive == 1);
            if (nonEncumdoc.length == 0) {
                setErrorMessage({ nonEncumDocError: "Please upload non-encumbrance document" });
                return false;
            }
            var valuationDoc = documentArray && documentArray.filter((item) => item.documentType === VALATION_REPORT && item.isActive == 1);
            if (valuationDoc.length == 0) {
                setErrorMessage({ valuationDocError: "Please upload valuation document" });
                return false;
            }
        }
        return true;
    }
    const validateDiv3 = () => {
        if (!details.temporaryStorageDetail.netWorth) {
            setErrorMessage({ ...errorMessage, netWorthError: "Please enter Net Worth " });
            return false;
        }
        else if (!details.temporaryStorageDetail.workingCapital) {
            setErrorMessage({ ...errorMessage, workingCapitalError: "Please enter Working Capital " });
            return false;
        }
        else if (!details.temporaryStorageDetail.storageAddress) {
            setErrorMessage({ ...errorMessage, locationAddressError: ADDRESS_ERROR });
            return false;
        }
        else if (details.temporaryStorageDetail.storagePincode.length != 6) {
            setErrorMessage({ ...errorMessage, locationPincodeError: PINCODE_NO_ERROR })
            return false;
        }
        else if (!details.temporaryStorageDetail.storageState) {
            setErrorMessage({ ...errorMessage, searchError: SEARCH_ICON_ERROR });
            return false;
        }
        else if (!details.temporaryStorageDetail.latitude) {
            setErrorMessage({ ...errorMessage, latitudesError: LATITUDE_ERROR });
            return false;
        }
        else if (!details.temporaryStorageDetail.longitude) {
            setErrorMessage({ ...errorMessage, longitudesError: LONGITUDE_ERROR });
            return false;
        }
        else if (!details.temporaryStorageDetail.landArea) {
            setErrorMessage({ ...errorMessage, landAreaError: LAND_AREA_ERROR });
            return false;
        }
        else if (!details.temporaryStorageDetail.latitude) {
            setErrorMessage({ latitudesError: "Please enter latitude" })
            return false;
        }
        else if (!details.temporaryStorageDetail.longitude) {
            setErrorMessage({ longitudesError: "Please enter longitude" })
            return false;
        }
        else if (!landArea || landArea.longitude == 0) {
            setErrorMessage({ landAreaError: "Please enter land area" })
            return false;
        }
        var locationDoc = documentArray && documentArray.filter((item) => item.documentType === GEOCODE_LOCATION && item.isActive == 1);
        if (locationDoc.length == 0) {
            setErrorMessage({ locationDocError: "Please upload land location image" });
            return false;
        }
        else {
            setErrorMessage({ locationDocError: "" });
        }
        var landDoc = documentArray && documentArray.filter((item) => item.documentType === LAND_DOCUMENT && item.isActive == 1);
        if (landDoc.length == 0) {
            setErrorMessage({ landDocError: "Please upload land document" });
            return false;
        }
        else {
            setErrorMessage({ landDocError: "" });
        }
        return true;
    };
    const onApplicantClick = (e) => {
        e.preventDefault()
        setSelectedApplicant(e.target.value)
        if (e.target.value == "Individual") {
            setDetails({ ...details, govtIdCardType: "Aadhaar ID", govtIdCardNumber: "" })
        }
        if (e.target.value != "Individual") {
            setDetails({ ...details, govtIdCardType: "MOA" })
        }
    }
    const isDisabled = () => {
        if (ResourceUpdateMember.includes(userRole)) {
            if (userRole === 'Reg-ITAdmin') {
                return false;
            }
            else { return true; }
        }
        else if (details?.registrationStatus === "Registered" || details?.registrationStatus === "ResourceUpdate" || details?.registrationStatus === "Scrutiny_Initiated") {
            if (appCountDisplay) {
                return false;
            }
            else
                return true;
        }
        else {
            return false;
        }
    }
    const isDisabledRegOnly = () => {
        if (ResourceUpdateMember.includes(userRole)) {
            return false;
        }
        else if (details?.registrationStatus === "Registered" || details?.registrationStatus === "ResourceUpdate" || details?.registrationStatus === "Scrutiny_Initiated") {
            if (appCountDisplay) {
                return false;
            }
            else
                return true;
        }
        else {
            return false;
        }
    }
    const isAdminEnable = () => {
        if (ResourceUpdateMember.includes(userRole)) {
            if (userRole === 'Reg-ITAdmin') {
                return false;
            }
            else { return true; }
        }
        else {
            return true;
        }
    }
    const ispreglledisabled = () => {
        if (ResourceUpdateMember.includes(userRole)) {
            if (userRole === 'Reg-ITAdmin') {
                return false;
            }
            else { return true; }
        }
        else if (isPreReg === true) {
            return false;
        }
        else {
            return true;
        }
    }
    const onRadioButtonClick = (e) => {
        if (e.target.name == "Owned_type") {
            setOwnershipType(e.target.value);
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, "ownershipType": e.target.value }, };
            });
        }
        else if (e.target.name == "landFillingRequired") {
            if (e.target.value === "Yes")
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, landFillingRequired: true }, };
                });
            else
                setDetails(current => {
                    return {
                        ...current, temporaryStorageDetail: {
                            ...current.temporaryStorageDetail, landFillingRequired
                                : false
                        },
                    };
                });
        }
        else if (e.target.name == "landFillingType") {
            setDetails(current => {
                return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, "landFillingType": e.target.value }, };
            });
        }
        else if (e.target.name == "existingBoundary") {
            if (e.target.value === "Yes")
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, existingBoundaryWall: true }, };
                });
            else
                setDetails(current => {
                    return {
                        ...current, temporaryStorageDetail: {
                            ...current.temporaryStorageDetail, existingBoundaryWall
                                : false
                        },
                    };
                });
        }
        else if (e.target.name == "isExistingInfrastructure") {
            if (e.target.value === "Yes")
                setDetails(current => {
                    return { ...current, temporaryStorageDetail: { ...current.temporaryStorageDetail, isExistingInfrastructure: true }, };
                });
            else
                setDetails(current => {
                    return {
                        ...current, temporaryStorageDetail: {
                            ...current.temporaryStorageDetail, isExistingInfrastructure
                                : false
                        },
                    };
                });
        }
    }
    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG15</p>}
                <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                    <BackButton navigate={navigate} />
                    <Typography variant="h5" gutterBottom>
                        {t('preReg.intrimStorage')}{t('preReg.r')} {t('preReg.pre-registration')}
                    </Typography>
                </Stack>
                <Card>
                    <CardContent>
                        <Grid item xs={12} hidden={!hidden.divPreview}>
                            <Typography variant="subtitle2" gutterBottom>
                                {t('preReg.applicantType')}
                            </Typography>
                            <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                                color="primary"
                                value={selectedApplicant}
                                exclusive
                                onChange={(e) => onApplicantClick(e)}
                                aria-label="Platform"
                            >

                                <ToggleButton name="applicantType" value="Individual" disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled() || hidden.div1 || !isPreReg}>{t('preReg.individual')}</ToggleButton>
                                <ToggleButton name="applicantType" value="Partnership" disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled() || hidden.div1 || !isPreReg}>{t('preReg.partnership')}</ToggleButton>
                                <ToggleButton name="applicantType" value="Proprietorship" disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled() || hidden.div1 || !isPreReg}>{t('preReg.proprietorship')}</ToggleButton>
                                <ToggleButton name="applicantType" value="Company" disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled() || hidden.div1 || !isPreReg}>{t('preReg.company')}</ToggleButton>
                            </ToggleButtonGroup>
                        </Grid>

                        <Grid container spacing={2} direction="row" mt={1} id='div1' hidden={hidden.div1}>
                            <Grid item xs={12} lg={6} >
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.fullNameError}
                                            helperText={errorMessage.fullNameError}
                                            type="text"
                                            label={t('preReg.applicantName')}
                                            name="name"
                                            value={details.name}
                                            onChange={(e) => handleChange(e)}
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled() || !isPreReg}
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                        />
                                        <BadgeComponent currentLength={details?.name?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.contactPersonDetails')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.salutation')}</InputLabel>
                                            <Select
                                                label={t('preReg.salutation')}
                                                disabled={ispreglledisabled()} name='contactPersonSalutation'
                                                onChange={(e) => handleChange(e)}
                                                value={details.contactPersonSalutation}>
                                                {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.contactPersonNameError}
                                            helperText={errorMessage.contactPersonNameError}
                                            type="text"
                                            disabled={ispreglledisabled()}
                                            label={t('preReg.firstname')}
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            name="contactPersonFirstname"
                                            value={details.contactPersonFirstname}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        <BadgeComponent currentLength={details?.contactPersonFirstname?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            disabled={ispreglledisabled()}
                                            label={t("preReg.middlename")}
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            name="contactPersonMiddlename"
                                            value={details.contactPersonMiddlename}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        <BadgeComponent currentLength={details?.contactPersonMiddlename?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            type="text"
                                            disabled={ispreglledisabled()}
                                            label={t('preReg.lastname')}
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            name="contactPersonLastname"
                                            value={details.contactPersonLastname}
                                            onChange={(e) => handleChange(e)}
                                        />
                                        <BadgeComponent currentLength={details?.contactPersonLastname?.length} maxLength={maxNameLength} />
                                    </Grid>
                                    <Grid item xs={3}>
                                        <FormControl fullWidth>
                                            <InputLabel>{t('preReg.gender')}</InputLabel>
                                            <Select
                                                label={t('preReg.gender')}
                                                disabled={ispreglledisabled()} name='contactPersonGender'
                                                onChange={(e) => handleChange(e)}
                                                value={details.contactPersonGender}>
                                                {GENDER.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={9}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.mobileNoError}
                                            helperText={errorMessage.mobileNoError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.mobileNo')}
                                            name="mobileNo"
                                            inputProps={{
                                                maxLength: 10
                                            }}
                                            onKeyDown={(evt) => typeNumberValid(evt)}
                                            value={details.mobileNo}
                                            onChange={(e) => handleChange(e)}
                                            disabled={userRole === 'Reg-ITAdmin' ? isAdminEnable() : isDisabled() || mobileOTPValidated || !isPreReg} />
                                            <BadgeComponent currentLength={details?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                                        {mobileOTPValidated === true && <div className="commonVerifyText" hidden={!mobileOTPValidated}><a href="#">Verified</a>
                                            <img className="commonOtpImg" src={resolveIcon} alt="" /></div>}
                                    </Grid>
                                    {/*<Grid item xs={3}>*/}
                                    {/*    <TextField fullWidth*/}
                                    {/*        required*/}
                                    {/*        error={errorMessage.OTPSentError}*/}
                                    {/*        helperText={errorMessage.OTPSentError}*/}
                                    {/*        hidden={otpHidden}*/}
                                    {/*        type="number"*/}
                                    {/*        onChange={(e) => onOtpChange(e)}*/}
                                    {/*        value={otpValue}*/}
                                    {/*        label={t('preReg.otp')} />*/}
                                    {/*</Grid>*/}
                                    {/*<Grid item xs={12}>*/}
                                    {/*    {verifyMobileNo === true ?*/}
                                    {/*        <div>*/}
                                    {/*            <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend otp</a></div>*/}
                                    {/*        : mobileOTPValidated === true ? <div className="commonVerifyText" hidden={!mobileOTPValidated} ><a href="#" style={{ marginLeft: "4vw" }}>Verified</a>*/}
                                    {/*            <img className="commonOtpImg" src={resolveIcon} alt="" /></div> :*/}
                                    {/*            <button className="commonVerifyText" style={{ marginLeft: "0vw", float: "right" }} onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile no.</button>*/}
                                    {/*    }*/}
                                    {/*</Grid>*/}
                                    <Grid container spacing={1.5} hidden={isPreReg}>
                                        <Grid item xs={12}>
                                            <TextField fullWidth
                                                required
                                                error={errorMessage.panNumberError}
                                                helperText={errorMessage.panNumberError}
                                                disabled={isDisabled()}
                                                type="text"
                                                label={t('preReg.enterPanNo')}
                                                maxLength={10}
                                                name="panNumber"
                                                inputProps={{
                                                    style: { textTransform: "uppercase" }
                                                }}
                                                value={details.panNumber}
                                                onChange={(e) => handleChange(e)} />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FileUploadMUI key="PANCard"
                                                documentList={documentArray}
                                                documentType="PANCard"
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title={t('preReg.uploadPanDoc')}
                                                stakeholderType="temporaryStorage"
                                                disabled={isDisabled()}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="panDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.panDocError}</div> */}
                                        </Grid>
                                        {selectedApplicant === 'Individual' ?
                                            <>
                                                <Grid item xs={6}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('preReg.addressProof')}</InputLabel>
                                                        <Select
                                                            label={t('preReg.addressProof')}
                                                            disabled={isDisabled()}
                                                            name="govtIdCardType"
                                                            value={details.govtIdCardType}
                                                            onChange={(e) => handleChange(e)}
                                                        >
                                                            {GOV_ID_LIST.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}

                                                        </Select>
                                                    </FormControl>
                                                </Grid>

                                                <Grid item xs={6}>
                                                    <TextField fullWidth
                                                        error={errorMessage.idCardNumberError}
                                                        helperText={errorMessage.idCardNumberError}
                                                        disabled={isDisabled()}
                                                        type="text"
                                                        name="govtIdCardNumber"
                                                        label={details.govtIdCardType === "Aadhaar ID" ? t('preReg.enterLast4digit') : details.govtIdCardType === "Voter ID" ? t('preReg.enterVoterId') : details.govtIdCardType === "Driving Licence" ? t('preReg.enterDrivinglicense') : t('preReg.enterBankPassbookNo')}
                                                        value={details.govtIdCardNumber}
                                                        onChange={(e) => handleChange(e)}
                                                        inputProps={{
                                                            style: { textTransform: "uppercase" }
                                                        }}
                                                    />
                                                    <BadgeComponent currentLength={details?.govtIdCardNumber?.length} maxLength={govtIDcardLength} />
                                                </Grid>
                                            </> :
                                            <>
                                                <Grid item xs={details.govtIdCardType == "Other" ? 4 : 6}>
                                                    <FormControl fullWidth>
                                                        <InputLabel>{t('preReg.idProof')}</InputLabel>
                                                        <Select
                                                            label={t('preReg.idProof')}
                                                            disabled={isDisabled()}
                                                            name="govtIdCardType"
                                                            value={details.govtIdCardType}
                                                            onChange={(e) => handleChange(e)}
                                                        >
                                                            <MenuItem disabled> ID Proof</MenuItem>
                                                            {CONSTANTS.ID_PROOF_ARRAY.map((item) => <MenuItem value={item}>{item}</MenuItem>)}

                                                        </Select>
                                                    </FormControl>
                                                </Grid>
                                                {details.govtIdCardType == "Other" &&
                                                    <Grid item xs={4}>
                                                        <TextField fullWidth
                                                            error={errorMessage.otherCardError}
                                                            helperText={errorMessage.otherCardError}
                                                            disabled={isDisabled()}
                                                            type="text"
                                                            label={t('preReg.enterIdProof')}
                                                            name="otherGovtCardType"
                                                            value={details?.otherGovtCardType}
                                                            onChange={(e) => handleChange(e)}
                                                            inputProps={{
                                                                style: { textTransform: "uppercase" }
                                                            }} />
                                                    </Grid>}
                                                <Grid item xs={details.govtIdCardType == "Other" ? 4 : 6}>
                                                    <TextField fullWidth
                                                        disabled={isDisabled()}
                                                        error={errorMessage.idCardNumberError}
                                                        helperText={errorMessage.idCardNumberError}
                                                        type="text"
                                                        name="govtIdCardNumber"
                                                        inputProps={{
                                                            style: { textTransform: "uppercase" }
                                                        }}
                                                        label={details.govtIdCardType === "MOA" ? t('preReg.enterMOA') : details.govtIdCardType === "Registration Certificate" ? t('preReg.enterRegNo') : details.govtIdCardType === "GST" ? t('preReg.enterGSTNo') : t('preReg.enterNo')}
                                                        defaultValue={details.govtIdCardNumber}
                                                        onChange={(e) => handleChange(e)}
                                                    />
                                                </Grid>
                                            </>}
                                        <Grid item xs={12}>
                                            <FileUploadMUI key="IDProof"
                                                documentList={documentArray}
                                                documentType="IDProof"
                                                callBackDocumentUpload={onUploadCallBack}
                                                stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                                title="Upload IDProof Document"
                                                stakeholderType="temporaryStorage"
                                                disabled={isDisabled()}
                                                errorMessage={errorMessage}
                                                setErrorMessage={setErrorMessage}
                                                documentError="idProofDocError"
                                            />
                                            {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
                                        </Grid>
                                    </Grid>
                                </Grid>

                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.emailIdError}
                                            helperText={errorMessage.emailIdError}
                                            type="text"
                                            disabled={ispreglledisabled()}
                                            label={t('main.email')}
                                            name="emailId"
                                            inputProps={{
                                                style: { textTransform: "none" }
                                            }}
                                            value={details.emailId}
                                            onChange={(e) => handleChange(e)} />
                                            <BadgeComponent currentLength={details?.emailId?.length} maxLength={emailUrnPassMaxLength} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.addressError}
                                            helperText={errorMessage.addressError}
                                            disabled={ispreglledisabled()}
                                            type="text"
                                            label={t('main.officeAddressTitle')}
                                            name="officeAddress"
                                            multiline
                                            inputProps={{
                                                maxLength: addressMaxLength
                                            }}

                                            value={details.temporaryStorageDetail.officeAddress}
                                            onChange={(e) => handleChange(e)} />
                                            <BadgeComponent currentLength={details?.temporaryStorageDetail?.officeAddress?.length} maxLength={addressMaxLength} />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                    revenueNotRequired={true}
                                        pincode={details.temporaryStorageDetail?.officePincode}
                                        state={details.temporaryStorageDetail?.officeState}
                                        district={details.temporaryStorageDetail?.officeDistrict}
                                        revenueCircle={details.temporaryStorageDetail?.officeRevenueCircle}
                                        blockName={details.temporaryStorageDetail?.officeBlockName}
                                        onHandleCallback={setOfficeAddressData}
                                        pincodeError={errorMessage.pincodeError}
                                        searchError={errorMessage.searchError}
                                        handleChangeSelect={handleOfficeChangeSelect}
                                        isDisabled={ispreglledisabled()}
                                    />
                                </Grid>

                            </Grid>
                        </Grid>
                        <Grid container spacing={2} direction="row" mt={1} id='div2' hidden={hidden.div2}>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.bankDetails')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.bankAccountError}
                                            helperText={errorMessage.bankAccountError}
                                            disabled={isDisabled()}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            name="bankAccountNumber"
                                            inputProps={{
                                                style: { textTransform: "uppercase" }
                                            }}
                                            label={t('preReg.accountNo')}
                                            value={details.bankAccountNumber}
                                            onChange={(e) => handleChange(e)}
                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.accountHolderNameError}
                                            helperText={errorMessage.accountHolderNameError}
                                            disabled={isDisabled()}
                                            type="text"
                                            name="bankAccountHolderName"
                                            label={t('preReg.accountHolderName')}
                                            value={details.bankAccountHolderName}
                                            onChange={(e) => handleChange(e)}
                                            maxLength={30}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.ifscError}
                                            helperText={errorMessage.ifscError}
                                            disabled={isDisabled()}
                                            type="text"
                                            name="bankIfscCode"
                                            maxLength={11}
                                            label={t('preReg.ifscCode')}
                                            value={details.bankIfscCode}
                                            onChange={(e) => handleChange(e)}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton color="primary" aria-label="search"
                                                            disabled={isDisabled()}
                                                            onClick={() => getBankDetails()} >
                                                            <SearchIcon />
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                                maxLength: 11,
                                                style: { textTransform: "uppercase" }
                                            }}
                                        ></TextField>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            disabled
                                            required
                                            type="text"
                                            name="bankBranch"
                                            label={t('preReg.branch')}
                                            value={details.bankBranch}
                                            inputProps={{
                                                style: { textTransform: "uppercase" }
                                            }}
                                            onChange={(e) => handleChange(e)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FileUploadMUI key={BANK_CANCELLED_CHEQUE}
                                            documentList={documentArray}
                                            documentType={BANK_CANCELLED_CHEQUE}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                            title={t('preReg.uploadPassbookCancelledCheck')}
                                            stakeholderType="temporaryStorage"
                                            disabled={isDisabled()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="bankDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.bankDocError}</div> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.gstError}
                                            helperText={errorMessage.gstError}
                                            type="text"
                                            disabled={isDisabled()}
                                            name="gstNumber"
                                            label={t('preReg.gstNo')}
                                            inputProps={{
                                                style: { textTransform: "uppercase" }
                                            }}
                                            value={details.temporaryStorageDetail.gstNumber}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FileUploadMUI key={GST}
                                            documentList={documentArray}
                                            documentType={GST}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                            title={t('preReg.uploadGst')}
                                            stakeholderType="temporaryStorage"
                                            disabled={isDisabled()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="gstDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.gstDocError}</div> */}
                                    </Grid>
                                    <Grid item xs={12} >
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.nonEncumCertError}
                                            helperText={errorMessage.nonEncumCertError}
                                            type="text"
                                            disabled={isDisabled()}
                                            inputProps={{
                                                style: { textTransform: "uppercase" }
                                            }}
                                            name="nonEncumbranceCertificateNo"
                                            label={t('preReg.nonEcumbranceCertificateNo')}
                                            value={details.temporaryStorageDetail.nonEncumbranceCertificateNo}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FileUploadMUI key={NON_ENCUMBRANCE_CERTI}
                                            documentList={documentArray}
                                            documentType={NON_ENCUMBRANCE_CERTI}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                            title={t('preReg.uploadNonEcumbraceDoc')}
                                            stakeholderType="temporaryStorage"
                                            disabled={isDisabled()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="nonEncumDocError"
                                        />
                                        <div className='mandatory_field'>{errorMessage.nonEncumDocError}</div>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FileUploadMUI key={VALATION_REPORT}
                                            documentList={documentArray}
                                            documentType={VALATION_REPORT}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                            title={t('preReg.uploadValuationDueDiligence')}
                                            stakeholderType="temporaryStorage"
                                            disabled={isDisabled()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="valuationDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.valuationDocError}</div> */}
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    // required
                                                    // error={errorMessage.agreementSatrtDateError}
                                                    // helperText={errorMessage.agreementSatrtDateError}
                                                    label={t('preReg.agreementStartDate')}
                                                    inputFormat="DD/MM/YYYY"
                                                    value={agreementStartDateDisplay}
                                                    name="startDate"
                                                    onChange={(e) => handleDateChange(e, "startDate")}
                                                    disabled={isDisabledRegOnly()}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ paddingRight: '3%' }}
                                                    componentsProps={{
                                                        actionBar: { actions: ['clear'], }
                                                    }}
                                                />
                                            </LocalizationProvider>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.agreementSatrtDateError}</FormHelperText>

                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <FormControl fullWidth>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DesktopDatePicker
                                                    // required
                                                    // error={errorMessage.agreementEndDateError}
                                                    // helperText={errorMessage.agreementEndDateError}
                                                    inputFormat="DD/MM/YYYY"
                                                    minDate={moment(new Date()).format(API_DATE_FORMAT)}
                                                    label={t('preReg.agreementEndDate')}
                                                    name="endDate"
                                                    onChange={(e) => handleDateChange(e, "endDate")}
                                                    value={agreementEndDateDisplay}
                                                    disabled={isDisabledRegOnly()}
                                                    renderInput={(params) => <TextField {...params} />}
                                                    sx={{ paddingRight: '3%' }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FileUploadMUI key={LOI_ABRPL_AGREEMENT}
                                            documentList={documentArray}
                                            documentType={LOI_ABRPL_AGREEMENT}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                            title={t('preReg.uploadLoiAgreement')}
                                            stakeholderType="temporaryStorage"
                                            disabled={isDisabledRegOnly()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="agreementDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.agreementDocError}</div> */}
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} direction="row" mt={1} id='div3' hidden={hidden.div3}>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.financialInformation')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.netWorthError}
                                            helperText={errorMessage.netWorthError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            disabled={ispreglledisabled()}
                                            label={t('preReg.networth')}
                                            name="netWorth"
                                            inputProps={{
                                                maxLength: maxNameLength

                                            }}
                                            value={details.temporaryStorageDetail.netWorth}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.workingCapitalError}
                                            helperText={errorMessage.workingCapitalError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label={t('preReg.workingCapital')}
                                            disabled={ispreglledisabled()}
                                            name="workingCapital"
                                            inputProps={{
                                                maxLength: maxNameLength
                                            }}
                                            value={details.temporaryStorageDetail.workingCapital}
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="h6" style={{ marginBottom: "1em" }} gutterBottom>
                                            {t('preReg.informationOfOptedStorageLocation')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.locationAddressError}
                                            helperText={errorMessage.locationAddressError}
                                            type="text"
                                            disabled={ispreglledisabled()}
                                            label={t('preReg.fullAddress')}
                                            multiline
                                            inputProps={{
                                                maxLength: addressMaxLength
                                            }}
                                            name="storageAddress"
                                            value={details.temporaryStorageDetail.storageAddress} onChange={(e) => handleChange(e)} />
                                            <BadgeComponent currentLength={details?.temporaryStorageDetail?.storageAddress?.length} maxLength={addressMaxLength} />
                                    </Grid>
                                    <CommonPincodeMUI setErrorMessage={setErrorMessage} 
                                    revenueNotRequired={true}
                                        pincode={details.temporaryStorageDetail?.storagePincode}
                                        state={details.temporaryStorageDetail?.storageState}
                                        district={details.temporaryStorageDetail?.storageDistrict}
                                        revenueCircle={details.temporaryStorageDetail?.storageRevenueCircle}
                                        blockName={details.temporaryStorageDetail?.storageBlockName}
                                        onHandleCallback={setStorageAddressData}
                                        pincodeError={errorMessage.locationPincodeError}
                                        searchError={errorMessage.locationSearchError}
                                        handleChangeSelect={handleStorageChangeSelect}
                                        isDisabled={ispreglledisabled()}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                            <LocationPointMUI
                                                latitudeLabel="Latitude"
                                                longitudeLabel="Longitude"
                                                latitudeName={t('preReg.latitude')}
                                                longitudeName={t('preReg.longitude')}
                                                latitude={details?.temporaryStorageDetail?.latitude}
                                                longitude={details?.temporaryStorageDetail?.longitude}
                                                callBackLocation={onLocationPoint}
                                                isDisabled={ispreglledisabled()}
                                                latitudesError={errorMessage.latitudesError}
                                                longitudesError={errorMessage.longitudesError}
                                            />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FileUploadMUI key={GEOCODE_LOCATION}
                                            documentList={documentArray}
                                            documentType={GEOCODE_LOCATION}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                            title={t('preReg.uploadPlotImageWithTimeLocationStamp')}
                                            stakeholderType="temporaryStorage"
                                            disabled={isDisabledRegOnly()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="locationDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.locationDocError}</div> */}
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField fullWidth
                                            required
                                            error={errorMessage.landAreaError}
                                            helperText={errorMessage.landAreaError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            min="0"
                                            disabled={ispreglledisabled()}
                                            label={t('preReg.landArea')}
                                            name="landArea"
                                            value={landArea}
                                            onChange={(e) => handleChange(e)}
                                            InputProps={{
                                                endAdornment: (
                                                    <Select
                                                        variant="standard"
                                                        size="small"
                                                        disabled={ispreglledisabled()}
                                                        value={landAreaUnit}
                                                        name="landAreaUnit"
                                                        onChange={(e) => handleChange(e)}>
                                                        {LAND_AREA_UNIT.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                                                    </Select>
                                                ),
                                                maxLength: 6
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FormControl fullWidth>
                                            <Typography variant="subtitle1" gutterBottom>{t('preReg.ownnershipType')}</Typography>
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel control={<Radio name="Owned_type" checked={ownershipType === "Owned"} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e, true)} />} label={t('preReg.owned')} value="Owned" />
                                                <FormControlLabel control={<Radio name="Owned_type" checked={ownershipType === "Leased"} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e, false)} />} label={t('preReg.lease')} value="Leased" />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <FileUploadMUI key={LAND_DOCUMENT}
                                            documentList={documentArray}
                                            documentType={LAND_DOCUMENT}
                                            callBackDocumentUpload={onUploadCallBack}
                                            stakeholderDetailId={details?.temporaryStorageDetail?.id}
                                            title={ownershipType === "Leased" ? t('preReg.uploadJamabandiReceiptLandOwnerTax') : t('preReg.uploadJamabandiKhajnaTax')}
                                            stakeholderType="temporaryStorage"
                                            disabled={isDisabledRegOnly()}
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="landDocError"
                                        />
                                        {/* <div className='mandatory_field'>{errorMessage.landDocError}</div> */}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2} direction="row" mt={1} id='div4' hidden={hidden.div4}>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            {t('preReg.roadConnectivity')} :
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" gutterBottom>
                                            {t('preReg.roadConnectivityDescrip')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>{t('preReg.optedPlotIs')}</Typography>

                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel control={<Radio name="Opted_plot" checked={roadConnectivity === "Adjacent to an existing bitumen/block road"} disabled={ispreglledisabled()} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.adjacentToBitumenBlockRoad')} value="Adjacent to an existing bitumen/block road" />
                                            <br />
                                            <FormControlLabel control={<Radio name="Opted_plot" checked={roadConnectivity === "Adjacent to an existing motorable gravel road"} disabled={ispreglledisabled()} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.adjacentToMotorableGravelRoad')} value="Adjacent to an existing motorable gravel road" />
                                            <br />
                                            <FormControlLabel control={<Radio name="Opted_plot" checked={roadConnectivity === "Requires additional road development less than 500 meters"} disabled={ispreglledisabled()} onChange={(e) => roadConnectivityChange(e)} />} label={t('preReg.requireAdditionalRoad')} value="Requires additional road development less than 500 meters" />
                                        </RadioGroup>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            {t('preReg.powerConnectivity')} :
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" gutterBottom>
                                            {t('preReg.distanceFromDistribution')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>

                                        <Typography variant="subtitle1" gutterBottom>{t('preReg.powerConnectionAvailable')} :</Typography>
                                        <RadioGroup
                                            column
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel control={<Radio name="power-connection" checked={optedLocationPowerConnectionDistance === WITHIN_100_METER} disabled={ispreglledisabled()} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.within100mtr')} value={WITHIN_100_METER} />
                                            <FormControlLabel control={<Radio name="power-connection" checked={optedLocationPowerConnectionDistance === BTWN_100_500_METER} disabled={ispreglledisabled()} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.btwn100_500mtr')} value={BTWN_100_500_METER} />
                                            <FormControlLabel control={<Radio name="power-connection" checked={optedLocationPowerConnectionDistance === BTWN_500_1_METER} disabled={ispreglledisabled()} onChange={(e) => optedLocationPowerConnectionDistanceChnage(e)} />} label={t('preReg.btwn500mtr_1km')} value={BTWN_500_1_METER} />
                                        </RadioGroup>

                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} lg={6}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            {t('preReg.daytimePowerAvailability')} :
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body2" gutterBottom>
                                            {t('preReg.powerAvailabilityDescrip')}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12}>

                                        <Typography variant="subtitle1" gutterBottom>{t('preReg.powerAvailableFor')} :</Typography>
                                        <RadioGroup
                                            column
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel control={<Radio name="day-time-power" checked={daytimePowerAvailability === MORE_THAN_8_HR} disabled={ispreglledisabled()} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.moreThan8hour')} value={MORE_THAN_8_HR} />
                                            <FormControlLabel control={<Radio name="day-time-power" checked={daytimePowerAvailability === BTWN_6_8_HR} disabled={ispreglledisabled()} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.btwn6_8hour')} value={BTWN_6_8_HR} />
                                            <FormControlLabel control={<Radio name="day-time-power" checked={daytimePowerAvailability === BTWN_4_6_HR} disabled={ispreglledisabled()} onChange={(e) => onDaytimePowerAvailabilityChange(e)} />} label={t('preReg.btwn4_6hour')} value={BTWN_4_6_HR} />
                                        </RadioGroup>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            {t('preReg.landFillingRequired')} :
                                        </Typography>

                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel control={<Radio name="landFillingRequired" checked={details.temporaryStorageDetail?.landFillingRequired === true} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.yes')} value="Yes" />
                                            <br />
                                            <FormControlLabel control={<Radio name="landFillingRequired" checked={details.temporaryStorageDetail?.landFillingRequired === false} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.no')} value="No" />
                                        </RadioGroup>

                                    </Grid>
                                    {details.temporaryStorageDetail?.landFillingRequired === true &&
                                        <Grid item xs={12}>

                                            <RadioGroup
                                                column
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel control={<Radio name="landFillingType" checked={details.temporaryStorageDetail?.landFillingType === LESS_THAN_2_FEET} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e)} />} label={LESS_THAN_2_FEET} value={LESS_THAN_2_FEET} />
                                                <FormControlLabel control={<Radio name="landFillingType" checked={details.temporaryStorageDetail?.landFillingType === MORE_THAN_2_FEET} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e)} />} label={MORE_THAN_2_FEET} value={MORE_THAN_2_FEET} />
                                            </RadioGroup>

                                        </Grid>
                                    }
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            {t('preReg.existingBoundaryFenceOrWall')} :
                                        </Typography>

                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel control={<Radio name="existingBoundary" checked={details.temporaryStorageDetail?.existingBoundaryWall === true} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.yes')} value="Yes" />
                                            <br />
                                            <FormControlLabel control={<Radio name="existingBoundary" checked={details.temporaryStorageDetail?.existingBoundaryWall === false} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.no')} value="No" />
                                        </RadioGroup>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="subtitle1" gutterBottom>
                                            {t('preReg.anyExistingInfraOnPlot')} :
                                        </Typography>

                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                        >
                                            <FormControlLabel control={<Radio name="isExistingInfrastructure" checked={details.temporaryStorageDetail?.isExistingInfrastructure === true} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.yes')} value="Yes" />
                                            <br />
                                            <FormControlLabel control={<Radio name="isExistingInfrastructure" checked={details.temporaryStorageDetail?.isExistingInfrastructure === false} disabled={ispreglledisabled()} onChange={(e) => onRadioButtonClick(e)} />} label={t('preReg.no')} value="No" />
                                        </RadioGroup>

                                    </Grid>
                                    {details.temporaryStorageDetail?.isExistingInfrastructure === true &&
                                        <Grid item xs={12}>
                                            <TextField fullWidth
                                                type="text"
                                                disabled={ispreglledisabled()}
                                                label={t('preReg.existingInfrastructure')} name="existingInfrastructureOnPlot"
                                                inputProps={{
                                                    maxLength: 200
                                                }}
                                                value={details.temporaryStorageDetail.existingInfrastructureOnPlot}
                                                onChange={(e) => handleChange(e)} />
                                        </Grid>
                                    }

                                </Grid>
                            </Grid>
                        </Grid>
                        {!isPreReg && !hidden.divPreview && <Preview key={loadPreview} urn={details?.urn} confirm={(e) => confirmSubmission(e, true)} goBack={onGoBack} disabledbtn={isDisabledRegOnly()} />}
                    </CardContent>
                </Card>
                <Grid container spacing={1} hidden={!isPreReg}>
                    <Grid item xs={12}>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={checkTermChecked} onChange={(e) => handleCheckboxTerms(e)} disabled={checkTermDisable} />} label={<><label for="chkTerms"> I agree to the <a href={LINKS.PRIVACY_POLICY}>Privacy Policy</a> and <a href={LINKS.TERMS_OF_USE}>Terms of Use</a> of ABEPL.</label></>} ></FormControlLabel>
                        </FormGroup>
                        <div style={{ color: "#d32f2f", fontSize: "0.75 rem" }}>{errorMessage.acceptTermError}</div>
                    </Grid>
                    <Grid item xs={3}>
                        {verifyMobileNo &&

                            <TextField fullWidth
                                type="number"
                                onFocus={handleNumberFieldFocus}
                                onKeyDown={(evt) => typeNumberValid(evt)}
                                onChange={(e) => onOtpChange(e)}
                                label={t('preReg.otp')}
                                value={otpValue} />

                        }
                        {verifyMobileNo === true &&
                            <div>
                                <a href='#' className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</a></div>
                        }
                    </Grid>
                </Grid>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }} hidden={!hidden.divPreview}>
                    <Button sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onPrevious(e)} hidden={!hidden.div1} startIcon={<ArrowBackIosNewIcon />}>{t('preReg.previous')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => SaveAndExit(false)} hidden={isPreReg} disabled={isDisabledRegOnly()} startIcon={<SaveIcon />}>{t('preReg.save&exit')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" type="button" onClick={(e) => onSubmit(e)} hidden={!hidden.div4} endIcon={<ArrowForwardIosIcon />} disabled={!mobileOTPValidated}>{t('preReg.next')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" onClick={(e) => isPreReg ? confirmSubmissionPreReg(e) : showPreview(e)} hidden={hidden.div4} endIcon={<SubmitIcon />}>{isPreReg ? t('preReg.submit') : t('preReg.preview')}</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={logModalOpen} onConfirm={Submit} action="Submit" onClose={handleConfirmLogModalClose} />
            <ConfirmationPopover onOpen={logModalOpenPreReg} onConfirm={submitPreReg} action="Submit" onClose={handlePreRegLogModalClose} />
            <PreRegPopover onOpen={logModalOpenSuccess} onClose={handleLogModalSuccessClose} urn={storageDetails?.temporaryStorage?.regStakeholderMaster?.urn} message={"Interim storage operator created successfully"} navigate={navigate} navigatePath={decoded != null && decoded && decoded.emails && decoded.emails[0] ? '/registrationHome/dashboard' : '/'} />
        </>

    );
}

export default TemporaryStorageDetails;
